import { useState, useEffect } from "react";
import { UrlDev as Url } from "../../../url";
import '../../../entrydoor.css';
import './DoorItems.css';

const DoorItems = ({ value, onChange, selectedCollection, selectedGrainFilter,
                     doorSizeValueToFunc, doorHeightValueToFunc, searchByName = null,
                     label = "Panels" }) => {
    const [items, setItems] = useState([]);
    const [selectedPanel, setSelectedPanel] = useState(null);

    useEffect(() => {
        if (!doorSizeValueToFunc) return;

        const w = doorSizeValueToFunc + '"';
        const h = doorHeightValueToFunc + '"';
        const url = `${Url}/doorpanels?width=${encodeURIComponent(w)}&height=${encodeURIComponent(h)}`;
        console.log("DoorItems fetch:", url);

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                let filtered = Array.isArray(data) ? data : [];

                if (selectedCollection)
                    filtered = filtered.filter(item => item.panel === selectedCollection);
                if (selectedGrainFilter)
                    filtered = filtered.filter(item => item.grain === selectedGrainFilter);
                if (searchByName)
                    filtered = filtered.filter(item => item.value.toLowerCase().includes(searchByName.toLowerCase()));

                setItems(filtered);
                // if current selection is no longer in filtered list, clear it
                setSelectedPanel(prev => filtered.find(i => i.id === prev?.id) ? prev : null);
            })
            .catch((error) => {
                console.error("DoorItems fetch error:", error);
                setItems([]);
            });
    }, [selectedCollection, selectedGrainFilter, doorSizeValueToFunc, doorHeightValueToFunc, searchByName]);

    // notify parent when selectedPanel changes
    useEffect(() => {
        onChange(selectedPanel);
    }, [selectedPanel]);

    const handleSelect = (item) => {
        setSelectedPanel(prev => prev?.id === item.id ? null : item);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorItems">{label}</label>
            <div className="door-items-container">
                {items.length > 0 ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="door-item"
                            onClick={() => handleSelect(item)}
                            style={{
                                cursor: "pointer",
                                textAlign: "center",
                                width: '120px',
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "flex-start",
                            }}
                        >
                            <img
                                src={`/images/${item.image}`}
                                alt={item.value}
                                style={{ alignSelf: "center", verticalAlign: "top" }}
                            />
                            <p style={{
                                fontWeight: selectedPanel?.id === item.id ? "bold" : "normal",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                textAlign: "center",
                                lineHeight: "1.2",
                                margin: "5px 0",
                            }}>
                                {item.value}
                            </p>
                        </div>
                    ))
                ) : (
                    <p>No panels available.</p>
                )}
            </div>
        </div>
    );
};

export default DoorItems;
